<template>
  <div id="login-container">
    <div id="logo">
      <router-link to="/index">
        <img src="../../assets/img/logo.png" alt="" />
      </router-link>
    </div>
    <div id="denglu">
      <img src="../../assets/img/yonghudenglu.png" alt="" />
    </div>
    <div id="login-box">
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
        <el-form-item prop="username" label-width="100px">
          <b class="icon-user">手机号：</b>
          <el-input
            v-model="loginForm.username"
            placeholder="请输入手机号"
            class="username-style"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label-width="100px">
          <b class="icon-pass">密码：</b>
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            class="password-style"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-link type="primary" class="zhuce" @click="zhucexianze()"
          >注册</el-link
        >
        <!-- <router-link to="apply" class="zhuce">注册</router-link> -->
        <el-link type="primary" class="wangji" @click="wangjimimaye()"
          >忘记密码</el-link
        >
        <!-- <router-link to="forget" class="wangji">忘记密码</router-link> -->
        <el-form-item size="large" class="login-but">
          <el-button type="primary" @click="login()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="zhucexuanxiang">
      <el-row :gutter="10">
        <h3>请选择您要注册的账号</h3>
        <el-col :span="12">
          <el-card class="box-card" @click.native="geren()" shadow="hover">
            <img
              style="width:30%;"
              src="../../assets/img/gerenzhuce.png"
              alt=""
            />
            <h3>个人账号注册</h3>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" @click.native="qiye()" shadow="hover">
            <img
              style="width:30%;"
              src="../../assets/img/qiyezhuce.png"
              alt=""
            />
            <h3>企业账号注册</h3>
          </el-card>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="zhucexuanxiang = false">取 消</el-button>
        <!-- <el-button type="primary" @click="caijitanchuang()">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zhucexuanxiang: false,
      // 表单校验规则定义
      loginFormRules: {
        username: [
          { required: true, message: "手机号必填", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码必填", trigger: "blur" },
          { min: 6, max: 20, message: "不小于六位", trigger: "blur" }
        ]
      },
      // form表单数据对象
      loginForm: {
        username: "", // 用户名称
        password: "" // 用户密码
      }
    };
  },
  methods: {
    qiye() {
      this.$router.push("/registered");
    },
    geren() {
      this.$router.push("/apply");
    },
    zhucexianze() {
      this.zhucexuanxiang = true;
    },
    wangjimimaye() {
      this.$router.push("/forget");
    },
    login() {
      // 登录表单做校验
      this.$refs.loginFormRef.validate(async valid => {
        // console.log(valid);
        // valid===true: 表单校验通过
        // valid===false: 表单校验失败
        if (valid === true) {
          // axios带着"用户名和密码"到达服务器端做有效性校验
          var { data: dt } = await this.$http.post(
            "user/login",
            this.loginForm
          );
          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          if (dt.data.status == 1) {
            return this.$message.error("账号或密码错误");
          }
          if (dt.data.status == 0) {
            return this.$message.error("登陆名不存在");
          }

          // 在前端通过sessionStorage把服务器返回的token令牌存储好
          // window.sessionStorage.setItem("token", dt.data.token);
          window.sessionStorage.setItem("userId", dt.data.data);

          // 编程式导航，进行路由跳转执行/home
          // console.log(dt.data.data);
          this.$router.push("/index");
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-row {
  text-align: center;
}
.box-card {
  cursor: pointer;
  text-align: center;
}
#login-container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  // height: auto !important;

  min-height: 800px;

  // position: fixed;
  // top: 0;
  // left: 0;
  background-image: url(../../assets/img/beijing10.png);
  // z-index: -10;
  overflow: auto;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  #logo {
    margin-top: 40px;
    margin-left: 40px;
    margin-bottom: 60px;
    overflow: hidden;
  }

  #denglu {
    width: 235px;
    height: 55px;
    display: block;
    margin: 0 auto;
  }

  #login-box {
    position: absolute;
    width: 520px;
    height: 400px;
    background-color: #fff;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 50px;
    // margin-left: 700px;
    position: relative;
    .el-input {
      width: 320px;
      height: 40px;
    }
    .username-style {
      margin-top: 90px;
      // margin-left: 100px;
    }
    .password-style {
      margin-top: 30px;
      // margin-left: 100px;
    }
    .icon-user {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: 50px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .icon-pass {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: -10px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .el-button {
      width: 320px;
      height: 50px;
    }
    .login-but {
      position: absolute;
      bottom: 0;
      right: 0;
      margin-bottom: 60px;
      margin-right: 100px;
    }
    .zhuce {
      position: absolute;
      left: 100px;
      color: #0086fd;
    }
    .wangji {
      position: absolute;
      left: 360px;
      color: #0086fd;
    }
  }
}
</style>
